import styles from '../styles/Yori.module.css';

// Components
import GoBackSection from '../components/GoBackSection';

// Images
import display from '../images/projects/yori.png'

export default function Yori() {
  return (
    <>
      <GoBackSection section="projects"/>
      <div className={styles.container}>
        <div>
          <p style={{fontSize: "32px", fontFamily: "var(--font-Alegreya)", color: "var(--color-darkblue)"}}>
            Yori - Recipe & Mini Game App
          </p>
          <p style={{width: "500px"}}>
            A mobile web application cook-book that promotes a variety of healthy, 
            affordable meals. Through its interactive children-friendly features, 
            it provides a platform for families to involve their children in the cooking 
            process. With its enchanting interactive features tailored for children, Yori 
            transcends a simple recipe collection, serving as a captivating platform for 
            families to immerse their young ones in the art of cooking.
          </p>
          <p>
            <span style={{fontWeight: "800", color: "var(--color-darkblue)", paddingRight: '15px'}}>Role</span>
            Front-end Developer & UX-UI Reseacher
          </p>
          <p>
            <span style={{fontWeight: "800", color: "var(--color-darkblue)", paddingRight: '15px'}}>Tool used</span>
            React, NodeJS, Illustrator, & Figma. 
          </p>
          <p style={{marginBottom: "30px"}}>
            <span style={{fontWeight: "800", color: "var(--color-darkblue)", paddingRight: '15px'}}>Period</span>
            Feb. 2023 - Mar. 2023
          </p>
          <div className={styles.linkContainer}>
            <a className={styles.button} href='https://github.com/Andreawz3/dynamic-content-design-project' target="_blank">View GitHub</a>
            <a 
              className={styles.button} 
              href='https://yori-nutritional-foods.vercel.app/' 
              target="_blank"
            >
              Explore Now
            </a>
          </div>
        </div>
        <img className={styles.image} src={display} alt='project-img'/>
      </div>
    </>
  )
}